module.exports = __webpack_public_path__ + "static/media/Logo.a8c6f05b.svg";